module.exports = __webpack_public_path__ + "img/727167_2F2F2B_A3A6A2_44443C-256px.a6b9262e.png";